import { StatusConsultaEnum } from '../service-proxies/service-proxies';

export class StatusItem {
    constructor(public name: string, public type: StatusConsultaEnum) { }
}

export class StatusList {
    status: StatusItem[] = [
        new StatusItem('Confirmada', StatusConsultaEnum._0),
        new StatusItem('Cancelada', StatusConsultaEnum._1),
        new StatusItem('Agendada', StatusConsultaEnum._2),
        new StatusItem('Realizada', StatusConsultaEnum._3),
    ];

    getNomeGrafico(status: StatusConsultaEnum): string {
        const item = this.status.find(x => x.type === status);
        return item ? item.name : 'Nome não encontrado';
    }
}